// Shared comparator for the client-side sortable admin tables.

// Resolving a collator per comparison is the expensive part of
// localeCompare-with-options, and compareValues runs O(n log n) times per sort.
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

export function isEmpty(v) {
  return v === null || v === undefined || v === "";
}

// Plain natural-order text comparison, with no empty-value special casing —
// for tie-breaker sorts where "" should compare as a value, not sort last.
export function naturalCompare(a, b) {
  return collator.compare(a, b);
}

// Empty values always sort last regardless of direction; numbers compare
// numerically; everything else compares as natural-order text.
export function compareValues(av, bv, dir) {
  const aNull = isEmpty(av);
  const bNull = isEmpty(bv);
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  if (typeof av === "number" && typeof bv === "number") return (av - bv) * dir;
  return collator.compare(String(av), String(bv)) * dir;
}
